module.exports = __webpack_public_path__ + "img/patient-info-mobile-fr.42aad208.jpg";